import React, { useEffect, useState } from "react";
import { getEmployees, saveEmployee, getEmployeesWithDetails } from "../../components/Api/GmsEmployee";
import Swal from "sweetalert2";
import API_URL from '../../config';
import { getGenders } from "../../components/Api/GmsGender";
import { getCountries } from "../../components/Api/GmsCountry";
import { getBusinesses } from "../../components/Api/GmsBusiness";
import { getDepartments } from "../../components/Api/GmsDepartment";
import { getDesignations } from "../../components/Api/GmsDesignation";
import { getBranches } from "../../components/Api/GmsBranch";
import { 
  hasPagePermissionWithAdmin, 
  hasViewOnlyPermission, 
  hasEditOrHigherPermission, 
  hasDeletePermissionWithAdmin, 
  isUserAdmin 
} from "../../components/Permission/PermissionService";
import { Card, CardBody, CardTitle, Col, Container, Form, FormGroup, Input, Label, NavItem, NavLink, Row, TabContent, TabPane, Button, Table, Modal, ModalHeader, ModalBody } from "reactstrap";
import Select from "react-select";
import classnames from "classnames";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagination from "rc-pagination";
import 'bootstrap/dist/css/bootstrap.min.css';
import Country from "../Master/Country";
import Department from "../Master/Department";
import Designation from "../Master/Designation";

const defaultForm = {
  employee_Id: null,
  employee_Code: "",
  employee_NameEn: "",
  employee_NameAr: "",
  employee_Business_Id: null,
  employee_Department_ID: null,
  employee_Designation_ID: null,
  employee_Branch_Id: null,
  employee_Gender_Id: null,
  employee_Country_Id: null,
  employee_Address1: "",
  employee_Address2: "",
  employee_BirthDate: "",
  employee_JoinDate: "",
  employee_NatID: "",
  employee_NatID_Date: "",
  employee_NatID_ExpDate: "",
  employee_PassportNumber: "",
  employee_Passport_Date: "",
  employee_Passport_ExpDate: "",
  employee_VisaNumber: "",
  employee_Visa_Date: "",
  employee_Visa_ExpDate: "",
  employee_ServiceEndDate: "",
  employee_BS: 0,
  employee_HRA: 0,
  employee_TA: 0,
  employee_OA: 0,
  employee_GS: 0,
  employee_IsOnProbation: true,
  employee_CreatedDate: new Date(),
  employee_CreatedBy: Number(localStorage.getItem("userId")) || 1,
  employee_ModifiedDate: new Date(),
  employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
  employee_ImagePath: null,
  employee_Email: "",
  employee_LabourCardNumber: "",
  employee_LabourCardExpiry: "",
  employee_EmploymentType: "Permanent",
  employee_FoodAllowance: 0,
  employee_CommunicationAllowance: 0,
  employee_UtilityAllowance: 0,
  employee_HousingProvided: false,
  employee_TelephoneProvided: false,
  employee_FoodProvided: false,
  employee_OtherBenefits: false,
  employee_HousingAmount: 0,
  employee_TelephoneAmount: 0,
  employee_FoodAmount: 0,
  employee_OtherBenefitsAmount: 0,
  employee_ContactNumber1: "",
  employee_ContactNumber2: "",
  // New fields
  onWork: true,
  emp_No: "",
  wpsSalary: 0,
};

const emptyFilter = {
  employee_Id: null,
  employee_Code: "",
  employee_NameEn: "",
  employee_NameAr: "",
  employee_CreatedDate: null,
  employee_CreatedBy: null,
  employee_ModifiedDate: null,
  employee_ModifiedBy: null,
  employee_Business_Id: null,
  employee_Gender_Id: null,
  employee_BirthDate: null,
  employee_JoinDate: null,
  employee_Department_ID: null,
  employee_Designation_ID: null,
  employee_Branch_Id: null,
  employee_Country_Id: null,
  Branch: "",
  Gender: "",
  employee_Passport_Date: null,
  employee_Passport_ExpDate: null,
  employee_NatID: "",
  employee_NatID_Date: null,    
  employee_NatID_ExpDate: null,
  employee_PassportNumber: "",
  employee_VisaNumber: "",
  employee_Visa_Date: null,
  employee_Visa_ExpDate: null,
  employee_Address1: "",
  employee_Address2: "",
  employee_ServiceEndDate: null,
  Country: "",
  Department: "",
  Designation: "",
  business_Name: "",
  employee_Email: "",
  employee_EmploymentType: null,
  employee_LabourCardNumber: "",
  employee_LabourCardExpiry: "",
  employee_FoodAllowance: null,
  employee_CommunicationAllowance: null,
  employee_UtilityAllowance: null,
  employee_HousingProvided: null,
  employee_TelephoneProvided: null,
  employee_FoodProvided: null,
  employee_OtherBenefits: null,
  employee_HousingAmount: null,
  employee_TelephoneAmount: null,
  employee_FoodAmount: null,
  employee_OtherBenefitsAmount: null,
  employee_ContactNumber1: "",
  employee_ContactNumber2: "",
  // New fields
  onWork: null,
  emp_No: "",
  wpsSalary: null,
};

const FormSelect = ({ label, id, name, options, value, onChange, error, required = true }) => (
  <div className="form-group">
    <Label className="col-form-label" htmlFor={id}>
      {label} {required && '*'}
    </Label>
    <Select
      id={id}
      name={name}
      options={options}
      value={value}
      onChange={onChange}
      isClearable
      isSearchable
      placeholder={`Select ${label}`}
      classNamePrefix="select2-selection"
      className={error ? 'is-invalid' : ''}
    />
    {error && (
      <div className="invalid-feedback d-block">
        {error}
      </div>
    )}
  </div>
);

const FormInput = ({ label, id, name, type = "text", value, onChange, error, required = true, placeholder, disabled = false }) => (
  <div className="form-group">
    <Label className="col-form-label" htmlFor={id}>
      {label} {required && '*'}
    </Label>
    <Input
      type={type}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      id={id}
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
    />
    {error && (
      <div className="invalid-feedback d-block">
        {error}
      </div>
    )}
  </div>
);

const FormCheckbox = ({ label, id, name, checked, onChange, disabled = false }) => (
  <div className="form-group mt-4">
    <div className="form-check form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={id}>
        {label === "Active" ? (checked ? "Active" : "Inactive") : label}
      </label>
    </div>
  </div>
);

const FormBenefitCheckbox = ({ label, checkboxName, amountName, checkboxChecked, amountValue, onCheckboxChange, onAmountChange }) => (
  <div className="benefit-item">
    <div className="form-check">
      <Input
        type="checkbox"
        className="form-check-input"
        id={checkboxName}
        name={checkboxName}
        checked={checkboxChecked}
        onChange={onCheckboxChange}
      />
      <Label className="form-check-label" htmlFor={checkboxName}>
        {label}
      </Label>
    </div>
    {checkboxChecked && (
      <div className="mt-2">
        <Input
          type="number"
          name={amountName}
          value={amountValue || 0}
          onChange={onAmountChange}
          placeholder="Enter amount"
          min="0"
          step="any"
          className="form-control-sm"
        />
      </div>
    )}
  </div>
);

// Add this component for image preview
const ImagePreview = ({ file, existingImage }) => {
  if (!file && !existingImage) return null;

  let imageUrl;
  if (file) {
    imageUrl = URL.createObjectURL(file);
  } else if (existingImage) {
    // Prepend API_URL if existingImage is a relative path
    imageUrl = existingImage.startsWith('http') ? existingImage : `${API_URL}${existingImage}`;
  }
  
  return (
    <div className="mt-2">
      <img 
        src={imageUrl} 
        alt="Employee" 
        style={{ 
          maxWidth: '200px', 
          maxHeight: '200px', 
          objectFit: 'cover',
          borderRadius: '8px'
        }} 
      />
    </div>
  );
};

export default function EmployeePage() {
  const [employees, setEmployees] = useState([]);
  const [genders, setGenders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [errors, setErrors] = useState({});
  
  // Check permissions
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const hasPermission = hasPagePermissionWithAdmin(permissions, '/GmsEmployee');
  const isViewOnly = hasViewOnlyPermission(permissions, '/GmsEmployee');
  const hasEditOrHigher = hasEditOrHigherPermission(permissions, '/GmsEmployee');
  const hasDeletePermission = hasDeletePermissionWithAdmin(permissions, '/GmsEmployee');
  const isAdmin = isUserAdmin();
  
  // Set default tab based on permissions
  useEffect(() => {
    if (isViewOnly) {
      setActiveTab(2); // Show list tab for view-only users
    }
  }, [isViewOnly]);
  
  // Function to copy Address1 to Address2
  const copyAddress1ToAddress2 = () => {
    setForm(prevForm => ({
      ...prevForm,
      employee_Address2: prevForm.employee_Address1
    }));
  };
  const [businesses, setBusinesses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [filter, setFilter] = useState(emptyFilter);
  const [showFilters, setShowFilters] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  useEffect(() => {
    if (hasPermission) {
      loadEmployees();
      const fetchData = async () => {
      try {
        const [
          gendersData, 
          countriesData, 
          businessesData,
          departmentsData,
          designationsData,
          branchesData
        ] = await Promise.all([
          getGenders(),
          getCountries(),
          getBusinesses({}),
          getDepartments({}),
          getDesignations({}),
          getBranches({})
        ]);

        console.log('API Responses:', {
          genders: gendersData,
          countries: countriesData,
          businesses: businessesData,
          departments: departmentsData,
          designations: designationsData,
          branches: branchesData
        });

        setGenders(gendersData || []);
        setCountries(countriesData || []);
        setBusinesses(businessesData || []);
        setDepartments(departmentsData || []);
        setDesignations(designationsData || []);
        setBranches(branchesData || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Set empty arrays if API calls fail
        setGenders([]);
        setCountries([]);
        setBusinesses([]);
        setDepartments([]);
        setDesignations([]);
        setBranches([]);
      }
    };
    fetchData();
    } else {
      window.location.href = '/Dashboard';
    }
  }, [page, hasPermission]);

  const loadEmployees = async (filterData = emptyFilter) => {
    setLoading(true);
    try {
      const data = await getEmployeesWithDetails(filterData);
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedData = data.slice(startIndex, endIndex);
      setEmployees(paginatedData);
      setTotalCount(data.length);
    } catch (error) {
      alert("Error loading employees: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = type === "checkbox" ? checked : value;

    // Handle numeric fields
    if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA', 'wpsSalary',
         'employee_FoodAllowance', 'employee_CommunicationAllowance', 'employee_UtilityAllowance',
         'employee_HousingAmount', 'employee_TelephoneAmount', 'employee_FoodAmount', 'employee_OtherBenefitsAmount'].includes(name)) {
      // Prevent negative values
      if (value < 0) {
        setErrors(prev => ({
          ...prev,
          [name]: "Amount cannot be negative"
        }));
        return;
      }
      // Allow empty values to be converted to 0
      processedValue = value === '' ? 0 : parseFloat(value) || 0;

      // Special validation for WPS salary
      if (name === 'wpsSalary') {
        const currentGrossSalary = 
          Number(form.employee_BS || 0) +
          Number(form.employee_HRA || 0) +
          Number(form.employee_TA || 0) +
          Number(form.employee_OA || 0) +
          Number(form.employee_FoodAllowance || 0) +
          Number(form.employee_CommunicationAllowance || 0) +
          Number(form.employee_UtilityAllowance || 0);

        if (processedValue > currentGrossSalary) {
          setErrors(prev => ({
            ...prev,
            [name]: "WPS Salary cannot exceed Gross Salary"
          }));
          return;
        }
      }
    }

    const updatedForm = { ...form, [name]: processedValue };

    // Clear error if value is valid
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    // Calculate gross salary only from regular salary components (excluding WpsSalary)
    if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA',
         'employee_FoodAllowance', 'employee_CommunicationAllowance', 'employee_UtilityAllowance'].includes(name)) {
      const grossSalary = 
        Number(updatedForm.employee_BS || 0) +
        Number(updatedForm.employee_HRA || 0) +
        Number(updatedForm.employee_TA || 0) +
        Number(updatedForm.employee_OA || 0) +
        Number(updatedForm.employee_FoodAllowance || 0) +
        Number(updatedForm.employee_CommunicationAllowance || 0) +
        Number(updatedForm.employee_UtilityAllowance || 0);

      updatedForm.employee_GS = grossSalary;

      // Validate WPS salary against new gross salary
      if (Number(updatedForm.wpsSalary || 0) > grossSalary) {
        setErrors(prev => ({
          ...prev,
          wpsSalary: "WPS Salary cannot exceed Gross Salary"
        }));
        updatedForm.wpsSalary = grossSalary; // Automatically adjust WPS salary to match gross salary
      }
    }

    setForm(updatedForm);
  };

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value || null });
  };

  const handleSelectFormChange = (selectedOption, field) => {
    setForm(prevForm => {
      const updatedForm = {
        ...prevForm,
        [field]: selectedOption ? selectedOption.value : null
      };
      
      // If business is changed, clear branch selection and reset branch options
      if (field === 'employee_Business_Id') {
        updatedForm.employee_Branch_Id = null;
      }
      
      return updatedForm;
    });
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      console.log('Selected image:', {
        name: file.name,
        type: file.type,
        size: file.size
      });
      setSelectedImage(file);
    }
  };

  const resetForm = () => {
    setForm({
      ...defaultForm,
      employee_CreatedDate: new Date(),
      employee_CreatedBy: Number(localStorage.getItem("userId")) || 1,
      employee_ModifiedDate: new Date(),
      employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1
    });
    setSelectedImage(null);
    setIsEditing(false);
    setActiveTab(1);
    setErrors({});
    
    // Reset file input by recreating it
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  // Validation function for mandatory fields
  const validateMandatoryFields = () => {
    const newErrors = {};

    // Mandatory fields according to requirements
    if (!form.employee_NameEn?.trim()) {
      newErrors.employee_NameEn = "Employee Name (English) is required";
    }
    if (!form.emp_No?.trim()) {
      newErrors.emp_No = "Employee Number is required";
    }
    // Employee Number character limit validation
    if (form.emp_No && form.emp_No.length > 10) {
      newErrors.emp_No = "Employee Number cannot exceed 10 characters";
    }
    if (!form.employee_Gender_Id) {
      newErrors.employee_Gender_Id = "Gender is required";
    }
    if (!form.employee_ContactNumber1?.trim()) {
      newErrors.employee_ContactNumber1 = "Primary Contact Number is required";
    }
    if (!form.employee_NatID?.trim()) {
      newErrors.employee_NatID = "National ID is required";
    }
    if (!form.employee_NatID_ExpDate) {
      newErrors.employee_NatID_ExpDate = "National ID Expiry Date is required";
    }
    if (!form.employee_PassportNumber?.trim()) {
      newErrors.employee_PassportNumber = "Passport Number is required";
    }
    if (!form.employee_Passport_ExpDate) {
      newErrors.employee_Passport_ExpDate = "Passport Expiry Date is required";
    }
    if (!form.employee_VisaNumber?.trim()) {
      newErrors.employee_VisaNumber = "Visa Number is required";
    }
    if (!form.employee_Visa_ExpDate) {
      newErrors.employee_Visa_ExpDate = "Visa Expiry Date is required";
    }
    if (!form.employee_LabourCardNumber?.trim()) {
      newErrors.employee_LabourCardNumber = "Labour Card Number is required";
    }
    if (!form.employee_LabourCardExpiry) {
      newErrors.employee_LabourCardExpiry = "Labour Card Expiry Date is required";
    }
    if (!form.employee_JoinDate) {
      newErrors.employee_JoinDate = "Joining Date is required";
    }
    if (!form.employee_BS || form.employee_BS <= 0) {
      newErrors.employee_BS = "Basic Salary is required and must be greater than 0";
    }
    if (!form.employee_HRA || form.employee_HRA < 0) {
      newErrors.employee_HRA = "HRA is required and cannot be negative";
    }
    if (!form.wpsSalary || form.wpsSalary <= 0) {
      newErrors.wpsSalary = "WPS Salary is required and must be greater than 0";
    }
    // Additional required fields as requested
    if (!form.employee_Address1?.trim()) {
      newErrors.employee_Address1 = "Address 1 is required";
    }
    if (!form.employee_Business_Id) {
      newErrors.employee_Business_Id = "Business is required";
    }
    if (!form.employee_Department_ID) {
      newErrors.employee_Department_ID = "Department is required";
    }
    if (!form.employee_Designation_ID) {
      newErrors.employee_Designation_ID = "Designation is required";
    }
    if (!form.employee_Branch_Id) {
      newErrors.employee_Branch_Id = "Branch is required";
    }
    if (!form.employee_BirthDate) {
      newErrors.employee_BirthDate = "Birth Date is required";
    }

    console.log('Validation errors:', newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (loading) {
      return;
    }
    
    setLoading(true);
    
    console.log('Form data being submitted:', form);
    console.log('Mandatory fields check:');
    console.log('- Employee Name (English):', form.employee_NameEn);
    console.log('- Employee Number:', form.emp_No);
    console.log('- Gender:', form.employee_Gender_Id);
    console.log('- Primary Contact:', form.employee_ContactNumber1);
    console.log('- National ID:', form.employee_NatID);
    console.log('- National ID Expiry:', form.employee_NatID_ExpDate);
    console.log('- Passport Number:', form.employee_PassportNumber);
    console.log('- Passport Expiry:', form.employee_Passport_ExpDate);
    console.log('- Visa Number:', form.employee_VisaNumber);
    console.log('- Visa Expiry:', form.employee_Visa_ExpDate);
    console.log('- Labour Card Number:', form.employee_LabourCardNumber);
    console.log('- Labour Card Expiry:', form.employee_LabourCardExpiry);
    console.log('- Joining Date:', form.employee_JoinDate);
    console.log('- Basic Salary:', form.employee_BS);
    console.log('- HRA:', form.employee_HRA);
    console.log('- WPS Salary:', form.wpsSalary);

    // Validate mandatory fields
    const validationErrors = validateMandatoryFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Form validation failed. Errors:', validationErrors);
      Swal.fire("Validation Error", "Please fill in all mandatory fields", "error");
      return;
    }
    
    try {
      const formData = new FormData();
      
      // Handle image file
      if (selectedImage) {
        // If a new image is selected, append it
        formData.append('imageFile', selectedImage);
        console.log('New image file being sent:', {
          name: selectedImage.name,
          type: selectedImage.type,
          size: selectedImage.size
        });
      } else if (isEditing && form.employee_ImagePath) {
        // If editing and there's an existing image path but no new image selected,
        // create a dummy file to satisfy the backend requirement
        const dummyFile = new File([''], 'dummy.txt', { type: 'text/plain' });
        formData.append('imageFile', dummyFile);
        formData.append('keepExistingImage', 'true'); // Flag to tell backend to keep existing image
      }
      
      // Add all form fields to FormData with proper handling and correct backend field names
      console.log('Adding form fields to FormData:');
      
      // Map frontend field names to backend model property names (match exact casing)
      const fieldMapping = {
        'employee_Id': 'Employee_Id',
        'employee_Code': 'Employee_Code', 
        'employee_NameEn': 'Employee_NameEn',
        'employee_NameAr': 'Employee_NameAr',
        'employee_Gender_Id': 'Employee_Gender_Id',
        'employee_BirthDate': 'Employee_BirthDate',
        'employee_JoinDate': 'Employee_JoinDate',
        'employee_PassportNumber': 'Employee_PassportNumber',
        'employee_NatID': 'Employee_NatID',
        'employee_VisaNumber': 'Employee_VisaNumber',
        'employee_Passport_Date': 'Employee_Passport_Date',
        'employee_Passport_ExpDate': 'Employee_Passport_ExpDate',
        'employee_NatID_Date': 'Employee_NatID_Date',
        'employee_NatID_ExpDate': 'Employee_NatID_ExpDate',
        'employee_Visa_Date': 'Employee_Visa_Date',
        'employee_Visa_ExpDate': 'Employee_Visa_ExpDate',
        'employee_Country_Id': 'Employee_Country_Id',
        'employee_Address1': 'Employee_Address1',
        'employee_Address2': 'Employee_Address2',
        'employee_Department_ID': 'Employee_Department_ID',
        'employee_Designation_ID': 'Employee_Designation_ID',
        'employee_ServiceEndDate': 'Employee_ServiceEndDate',
        'employee_CreatedDate': 'Employee_CreatedDate',
        'employee_CreatedBy': 'Employee_CreatedBy',
        'employee_ModifiedDate': 'Employee_ModifiedDate',
        'employee_ModifiedBy': 'Employee_ModifiedBy',
        'employee_Business_Id': 'Employee_Business_Id',
        'employee_Branch_Id': 'Employee_Branch_Id',
        'employee_BS': 'Employee_BS',
        'employee_HRA': 'Employee_HRA',
        'employee_TA': 'Employee_TA',
        'employee_OA': 'Employee_OA',
        'employee_GS': 'Employee_GS',
        'employee_IsOnProbation': 'Employee_IsOnProbation',
        'employee_ImagePath': 'Employee_ImagePath',
        'employee_ContactNumber1': 'Employee_ContactNumber1',
        'employee_ContactNumber2': 'Employee_ContactNumber2',
        'employee_Email': 'Employee_Email',
        'employee_LabourCardNumber': 'Employee_LabourCardNumber',
        'employee_LabourCardExpiry': 'Employee_LabourCardExpiry',
        'employee_EmploymentType': 'Employee_EmploymentType',
        'employee_FoodAllowance': 'Employee_FoodAllowance',
        'employee_CommunicationAllowance': 'Employee_CommunicationAllowance',
        'employee_UtilityAllowance': 'Employee_UtilityAllowance',
        'employee_HousingProvided': 'Employee_HousingProvided',
        'employee_HousingAmount': 'Employee_HousingAmount',
        'employee_TelephoneProvided': 'Employee_TelephoneProvided',
        'employee_TelephoneAmount': 'Employee_TelephoneAmount',
        'employee_FoodProvided': 'Employee_FoodProvided',
        'employee_FoodAmount': 'Employee_FoodAmount',
        'employee_OtherBenefits': 'Employee_OtherBenefits',
        'employee_OtherBenefitsAmount': 'Employee_OtherBenefitsAmount',
        'onWork': 'OnWork',
        'emp_No': 'Emp_No',
        'wpsSalary': 'WpsSalary'
      };

      Object.keys(form).forEach(key => {
        const backendFieldName = fieldMapping[key] || key;
        
        if (key.includes('Date')) {
          // Format dates properly for backend
          if (form[key]) {
            const dateValue = new Date(form[key]).toISOString();
            formData.append(backendFieldName, dateValue);
            console.log(`Date field ${backendFieldName}:`, dateValue);
          } else {
            // Send null dates as empty string or current date for required fields
            if (['employee_CreatedDate', 'employee_ModifiedDate'].includes(key)) {
              const currentDate = new Date().toISOString();
              formData.append(backendFieldName, currentDate);
              console.log(`Required date field ${backendFieldName} (auto-set):`, currentDate);
            } else {
              formData.append(backendFieldName, '');
              console.log(`Optional date field ${backendFieldName}:`, 'empty');
            }
          }
        } else {
          // Handle non-date fields
          let value = form[key];
          
          // Ensure numeric fields are properly formatted
          if (['employee_Business_Id', 'employee_Department_ID', 'employee_Designation_ID', 
               'employee_Branch_Id', 'employee_Gender_Id', 'employee_Country_Id',
               'employee_CreatedBy', 'employee_ModifiedBy'].includes(key)) {
            value = value || 0;
          }
          
          // Ensure boolean fields are properly formatted
          if (['employee_IsOnProbation', 'onWork', 'employee_HousingProvided', 
               'employee_TelephoneProvided', 'employee_FoodProvided', 'employee_OtherBenefits'].includes(key)) {
            value = value === true || value === 'true' ? true : false;
          }
          
          // Ensure decimal fields are properly formatted
          if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA', 'employee_GS',
               'wpsSalary', 'employee_FoodAllowance', 'employee_CommunicationAllowance',
               'employee_UtilityAllowance', 'employee_HousingAmount', 'employee_TelephoneAmount',
               'employee_FoodAmount', 'employee_OtherBenefitsAmount'].includes(key)) {
            value = value || 0;
          }
          
          formData.append(backendFieldName, value !== null && value !== undefined ? value : '');
          console.log(`Field ${backendFieldName}:`, value);
        }
      });
      
      console.log('FormData entries:');
      for (let [key, value] of formData.entries()) {
        if (key === 'imageFile') {
          console.log('imageFile:', value.name);
        } else {
          console.log(key + ':', value);
        }
      }
      
      const response = await fetch(`${API_URL}/api/Employee/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });
      
      if (!response.ok) {
        if (response.status === 401) {
          // Import and use the session timeout handler
          const { handleSessionTimeout } = await import('../../components/Api/SessionTimeoutHandler');
          handleSessionTimeout();
          throw new Error('Session timed out. Please login again.');
        }
        
        // Try to get error details from response
        let errorMessage = 'Failed to save employee';
        try {
          const errorResponse = await response.json();
          console.error('Backend error response:', errorResponse);
          errorMessage = errorResponse.msg || errorResponse.message || errorMessage;
        } catch (e) {
          console.error('Could not parse error response:', e);
        }
        
        throw new Error(errorMessage);
      }
      
      const result = await response.json();
      console.log('Save employee response:', result);
      
      if (result.id) {  // Check for id in the response to determine success
        Swal.fire("Success", result.msg || "Employee saved successfully", "success");
        resetForm(); // Use the new reset function
        loadEmployees(); // Reload the employee list
      } else {
        Swal.fire("Error", result.msg || "Failed to save employee", "error");
      }
    } catch (error) {
      console.error('Error saving employee:', error);
      Swal.fire("Error", `Failed to save employee: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (employee) => {
    console.log("Edit employee:", employee);
    const formatDate = (dateString) => dateString ? new Date(dateString).toISOString().split('T')[0] : "";

    setForm({
      employee_Id: employee.employee_Id,
      employee_Code: employee.employee_Code || "",
      employee_NameEn: employee.employee_NameEn || "",
      employee_NameAr: employee.employee_NameAr || "",
      employee_Business_Id: employee.employee_Business_Id || null,
      employee_Department_ID: employee.employee_Department_ID || null,
      employee_Designation_ID: employee.employee_Designation_ID || null,
      employee_Branch_Id: employee.employee_Branch_Id || null,
      employee_Gender_Id: employee.employee_Gender_Id || null,
      employee_Country_Id: employee.employee_Country_Id || null,
      employee_Address1: employee.employee_Address1 || "",
      employee_Address2: employee.employee_Address2 || "",
      employee_BirthDate: formatDate(employee.employee_BirthDate),
      employee_JoinDate: formatDate(employee.employee_JoinDate),
      employee_NatID: employee.employee_NatID || "",
      employee_NatID_Date: formatDate(employee.employee_NatID_Date),
      employee_NatID_ExpDate: formatDate(employee.employee_NatID_ExpDate),
      employee_PassportNumber: employee.employee_PassportNumber || "",
      employee_Passport_Date: formatDate(employee.employee_Passport_Date),
      employee_Passport_ExpDate: formatDate(employee.employee_Passport_ExpDate),
      employee_VisaNumber: employee.employee_VisaNumber || "",
      employee_Visa_Date: formatDate(employee.employee_Visa_Date),
      employee_Visa_ExpDate: formatDate(employee.employee_Visa_ExpDate),
      employee_ServiceEndDate: formatDate(employee.employee_ServiceEndDate),
      employee_BS: employee.employee_BS || 0,
      employee_HRA: employee.employee_HRA || 0,
      employee_TA: employee.employee_TA || 0,
      employee_OA: employee.employee_OA || 0,
      employee_GS: employee.employee_GS || 0,
      employee_IsOnProbation: employee.employee_IsOnProbation || false,
      employee_CreatedDate: new Date(employee.employee_CreatedDate || new Date()),
      employee_CreatedBy: employee.employee_CreatedBy || Number(localStorage.getItem("userId")) || 1,
      employee_ModifiedDate: new Date(),
      employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
      employee_ImagePath: employee.employee_ImagePath || null,
      employee_Email: employee.employee_Email || "",
      employee_LabourCardNumber: employee.employee_LabourCardNumber || "",
      employee_LabourCardExpiry: formatDate(employee.employee_LabourCardExpiry),
      employee_EmploymentType: employee.employee_EmploymentType || "Permanent",
      employee_FoodAllowance: employee.employee_FoodAllowance || 0,
      employee_CommunicationAllowance: employee.employee_CommunicationAllowance || 0,
      employee_UtilityAllowance: employee.employee_UtilityAllowance || 0,
      employee_HousingProvided: employee.employee_HousingProvided || false,
      employee_TelephoneProvided: employee.employee_TelephoneProvided || false,
      employee_FoodProvided: employee.employee_FoodProvided || false,
      employee_OtherBenefits: employee.employee_OtherBenefits || false,
      employee_HousingAmount: employee.employee_HousingAmount || 0,
      employee_TelephoneAmount: employee.employee_TelephoneAmount || 0,
      employee_FoodAmount: employee.employee_FoodAmount || 0,
      employee_OtherBenefitsAmount: employee.employee_OtherBenefitsAmount || 0,
      employee_ContactNumber1: employee.employee_ContactNumber1 || "",
      employee_ContactNumber2: employee.employee_ContactNumber2 || "",
      // New fields
      onWork: employee.onWork || false,
      emp_No: employee.emp_No || "",
      wpsSalary: employee.wpsSalary || 0,
    });

    setIsEditing(true);
    setActiveTab(1);
  };

  const handleCancelEdit = () => {
    resetForm(); // Use the same reset function for consistency
  };

  const handleApplyFilter = () => {
    loadEmployees(filter);
  };

  const handleClearFilter = () => {
    setFilter(emptyFilter);
    loadEmployees(emptyFilter);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 2) {
        setActiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  };

  // Generate options for searchable dropdowns
  const employeeCodeOptions = [...new Set(employees.map(emp => emp.employee_Code).filter(Boolean))].map(code => ({
    value: code,
    label: code
  }));

  const employeeNameEnOptions = [...new Set(employees.map(emp => emp.employee_NameEn).filter(Boolean))].map(name => ({
    value: name,
    label: name
  }));

  const employeeNameArOptions = [...new Set(employees.map(emp => emp.employee_NameAr).filter(Boolean))].map(name => ({
    value: name,
    label: name
  }));

  const businessOptions = businesses.map(business => ({
    value: business.business_Id,
    label: `${business.business_NameEn} - ${business.business_NameAr}`
  }));

  // Transform gender and country data for Select component
  const genderOptions = genders.map(gender => ({
    value: gender.gender_Id,
    label: `${gender.gender_NameEn} - ${gender.gender_NameAr}`
  }));

  const countryOptions = countries.map(country => ({
    value: country.country_Id,
    label: `${country.country_NameEn} - ${country.country_NameAr}`
  }));

  const departmentOptions = departments.map(dept => ({
    value: dept.department_Id,
    label: `${dept.department_NameEn} - ${dept.department_NameAr}`
  }));

  const designationOptions = designations.map(desig => ({
    value: desig.designation_Id,
    label: `${desig.designation_NameEn} - ${desig.designation_NameAr}`
  }));

  // Filter branches based on selected business
  const filteredBranches = form.employee_Business_Id 
    ? branches.filter(branch => branch.branch_Buisness_Id === form.employee_Business_Id)
    : branches;

  const branchOptions = filteredBranches.map(branch => ({
    value: branch.branch_Id,
    label: `${branch.branch_NameEn} - ${branch.branch_NameAr}`
  }));

  // Filter branches for filter section based on selected business in filter
  const filteredBranchesForFilter = filter.employee_Business_Id 
    ? branches.filter(branch => branch.branch_Buisness_Id === filter.employee_Business_Id)
    : branches;

  const branchOptionsForFilter = filteredBranchesForFilter.map(branch => ({
    value: branch.branch_Id,
    label: `${branch.branch_NameEn} - ${branch.branch_NameAr}`
  }));

  const createdByOptions = [...new Set(employees.map(emp => emp.employee_CreatedBy).filter(Boolean))].map(id => ({
    value: id,
    label: id.toString()
  }));

  const modifiedByOptions = [...new Set(employees.map(emp => emp.employee_ModifiedBy).filter(Boolean))].map(id => ({
    value: id,
    label: id.toString()
  }));

  const handleSelectChange = (selectedOption, field) => {
    setFilter(prevFilter => {
      const updatedFilter = {
        ...prevFilter,
        [field]: selectedOption ? selectedOption.value : null
      };
      
      // If business is changed in filter, clear branch selection
      if (field === 'employee_Business_Id') {
        updatedFilter.employee_Branch_Id = null;
      }
      
      return updatedFilter;
    });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    loadEmployees(filter);
  };

  // Add this new function to handle view button click
  const handleView = (employee) => {
    setSelectedEmployee(employee);
    setViewModal(true);
  };

  // Add the Employee Details Modal component
  const EmployeeDetailsModal = ({ isOpen, toggle, employee }) => {
    if (!employee) return null;

    const InfoSection = ({ title, children }) => (
      <div className="employee-info-section">
        <h5 className="text-primary border-bottom">{title}</h5>
        <div className="px-2">{children}</div>
      </div>
    );

    const InfoItem = ({ label, value }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <span className="info-value">{value}</span>
      </div>
    );

    const DateRangeItem = ({ label, startDate, endDate }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <div className="date-range">
          <div className="small text-muted">
            <i className="bx bx-calendar me-1"></i>Valid from {formatDate(startDate)} to {formatDate(endDate)}
          </div>
        </div>
      </div>
    );

    const MoneyItem = ({ label, value }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <span className="salary-value">
          {value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>
      </div>
    );

    const BenefitItem = ({ label, isProvided, amount }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <div>
          <span className={`badge ${isProvided ? 'bg-success' : 'bg-secondary'} me-2`}>
            {isProvided ? 'Provided' : 'Not Provided'}
          </span>
          {isProvided && amount > 0 && (
            <span className="salary-value">
              Amount: {amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          )}
        </div>
      </div>
    );

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg" className="employee-details-modal">
        <ModalHeader toggle={toggle} className="border-bottom py-2">
          <i className="bx bx-user-circle me-2"></i>
          Employee Details
        </ModalHeader>
        <ModalBody className="p-3">
          <style>
            {`
              .employee-details-modal .modal-content {
                border-radius: 12px;
                box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
              }
              .employee-info-section {
                background-color: #fff;
                border-radius: 8px;
                padding: 15px;
                margin-bottom: 15px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
              }
              .info-item {
                display: flex;
                align-items: baseline;
                margin-bottom: 8px;
                padding: 4px 15px;
              }
              .info-label {
                min-width: 120px;
                color: #495057;
                font-size: 0.9rem;
                flex: 0 0 120px;
              }
              .info-value {
                flex: 1;
                padding-left: 15px;
                color: #212529;
              }
              .date-range {
                flex: 1;
                padding-left: 15px;
              }
              .profile-image-container {
                padding: 15px;
                text-align: center;
                background: linear-gradient(to bottom, #f8f9fa, #fff);
                border-radius: 8px;
                margin-bottom: 15px;
              }
              .salary-value {
                font-family: monospace;
                background-color: #f8f9fa;
                padding: 2px 8px;
                border-radius: 4px;
                color: #28a745;
              }
              .document-section {
                background-color: #f8f9fa;
                border-radius: 8px;
                padding: 8px;
                margin-top: 8px;
              }
              .modal-body {
                padding: 15px !important;
              }
              .row {
                margin-left: -7.5px;
                margin-right: -7.5px;
              }
              .col-md-6 {
                padding-left: 7.5px;
                padding-right: 7.5px;
              }
              h5.text-primary {
                font-size: 1rem;
                margin-bottom: 10px;
                padding-bottom: 8px;
              }
              .employee-details-modal .modal-content {
                max-height: 85vh;
                overflow-y: auto;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar {
                width: 8px;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-track {
                background: #f1f1f1;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 4px;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>

          <div className="profile-image-container">
            {employee.employee_ImagePath ? (
              <img
                src={`${API_URL}${employee.employee_ImagePath}`}
                alt={employee.employee_NameEn}
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '5px solid #fff',
                  boxShadow: '0 0 15px rgba(0,0,0,0.1)'
                }}
              />
            ) : (
              <div
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  backgroundColor: '#e9ecef',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                  border: '5px solid #fff',
                  boxShadow: '0 0 15px rgba(0,0,0,0.1)'
                }}
              >
                <i className="bx bx-user" style={{ fontSize: '64px', color: '#adb5bd' }} />
              </div>
            )}
            <h4 className="mt-3 mb-0">{employee.employee_NameEn}</h4>
            <p className="text-muted mb-0">{employee.employee_NameAr}</p>
          </div>

          <Row>
            <Col md="6">
              <InfoSection title="Personal Information">
                <InfoItem label="Employee Code" value={employee.employee_Code} />
                <InfoItem label="Employee Number" value={employee.emp_No} />
                <InfoItem label="Gender" value={employee.gender_name} />
                <InfoItem label="Birth Date" value={formatDate(employee.employee_BirthDate)} />
                <InfoItem label="Country" value={employee.country_name} />
                <InfoItem label="Email" value={employee.employee_Email} />
                <InfoItem label="Primary Contact" value={employee.employee_ContactNumber1} />
                <InfoItem label="Secondary Contact" value={employee.employee_ContactNumber2} />
                <InfoItem 
                  label="Work Status" 
                  value={
                    <span className={`badge ${employee.onWork ? 'bg-success' : 'bg-secondary'}`}>
                      {employee.onWork ? 'On Work' : 'Not On Work'}
                    </span>
                  } 
                />
              </InfoSection>

              <InfoSection title="Address Information">
                <InfoItem label="Address 1" value={employee.employee_Address1} />
                <InfoItem label="Address 2" value={employee.employee_Address2} />
              </InfoSection>

              <InfoSection title="Documents">
                <div className="document-section">
                  <InfoItem label="National ID" value={employee.employee_NatID} />
                  <DateRangeItem 
                    label="Validity"
                    startDate={employee.employee_NatID_Date}
                    endDate={employee.employee_NatID_ExpDate}
                  />
                </div>

                <div className="document-section mt-3">
                  <InfoItem label="Passport" value={employee.employee_PassportNumber} />
                  <DateRangeItem 
                    label="Validity"
                    startDate={employee.employee_Passport_Date}
                    endDate={employee.employee_Passport_ExpDate}
                  />
                </div>

                <div className="document-section mt-3">
                  <InfoItem label="Visa" value={employee.employee_VisaNumber} />
                  <DateRangeItem 
                    label="Validity"
                    startDate={employee.employee_Visa_Date}
                    endDate={employee.employee_Visa_ExpDate}
                  />
                </div>
              </InfoSection>
            </Col>

            <Col md="6">
              <InfoSection title="Employment Information">
                <InfoItem label="Company" value={employee.business_name} />
                <InfoItem label="Department" value={employee.department_name} />
                <InfoItem label="Designation" value={employee.designation_name} />
                <InfoItem label="Branch" value={employee.branch_name} />
                <InfoItem label="Join Date" value={formatDate(employee.employee_JoinDate)} />
                <InfoItem label="Employment Type" value={employee.employee_EmploymentType} />
                <InfoItem label="Labour Card Number" value={employee.employee_LabourCardNumber} />
                <InfoItem label="Labour Card Expiry" value={formatDate(employee.employee_LabourCardExpiry)} />
                <InfoItem 
                  label="Status" 
                  value={
                    <span className={`badge ${employee.employee_IsOnProbation ? 'bg-warning' : 'bg-success'}`}>
                      {employee.employee_IsOnProbation ? 'On Probation' : 'Confirmed'}
                    </span>
                  } 
                />
              </InfoSection>

              <InfoSection title="Salary Information">
                <MoneyItem label="Basic Salary" value={employee.employee_BS} />
                <MoneyItem label="HRA" value={employee.employee_HRA} />
                <MoneyItem label="Transport" value={employee.employee_TA} />
                <MoneyItem label="Other Allowance" value={employee.employee_OA} />
                <MoneyItem label="Food Allowance" value={employee.employee_FoodAllowance} />
                <MoneyItem label="Communication Allowance" value={employee.employee_CommunicationAllowance} />
                <MoneyItem label="Utility Allowance" value={employee.employee_UtilityAllowance} />
                <MoneyItem label="WPS Salary" value={employee.wpsSalary} />
                <div className="mt-3 pt-3 border-top">
                  <MoneyItem 
                    label="Gross Salary" 
                    value={employee.employee_GS}
                  />
                </div>
              </InfoSection>

              <InfoSection title="Group Benefits">
                <BenefitItem 
                  label="Housing Benefit"
                  isProvided={employee.employee_HousingProvided}
                  amount={employee.employee_HousingAmount}
                />
                <BenefitItem 
                  label="Telephone Benefit"
                  isProvided={employee.employee_TelephoneProvided}
                  amount={employee.employee_TelephoneAmount}
                />
                <BenefitItem 
                  label="Food Benefit"
                  isProvided={employee.employee_FoodProvided}
                  amount={employee.employee_FoodAmount}
                />
                <BenefitItem 
                  label="Other Benefits"
                  isProvided={employee.employee_OtherBenefits}
                  amount={employee.employee_OtherBenefitsAmount}
                />
              </InfoSection>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content space-optimized">
        <Container fluid={true}>
          <Breadcrumbs title="Employee" breadcrumbItem="Employee Management" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                  {/* <h4 className="card-title mb-4">Employee Management System</h4> */}
                  
                  {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                  {/* <h5 className="card-title mb-2">Employee Management System</h5> */}
                  
                  {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACING): */}
                  <div className="wizard clearfix" style={{marginTop: '0.5rem'}}>
                    <div className="steps clearfix">
                      <ul>
                        {hasEditOrHigher && (
                          <NavItem className={classnames({ current: activeTab === 1 })}>
                            <NavLink
                              className={classnames({ current: activeTab === 1 })}
                              onClick={() => setActiveTab(1)}
                              disabled={!(passedSteps || []).includes(1)}
                            >
                              <span className="number">1.</span> {isEditing ? "Edit Employee" : "Add Employee"}
                            </NavLink>
                          </NavItem>
                        )}
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => setActiveTab(2)}
                          >
                            <span className="number">2.</span> Employee List
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        {hasEditOrHigher && (
                          <TabPane tabId={1}>
                            <Form onSubmit={handleSubmit}>
                            {/* Personal Information Section */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Personal Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Personal Information</h6>
                            <Row className="mb-3">
                              <Col lg="3">
                                <div className="form-group">
                                  <Label className="col-form-label" htmlFor="emp_No">
                                    Employee Number *
                                  </Label>
                                  <Input
                                    type="text"
                                    className={`form-control ${errors.emp_No ? 'is-invalid' : ''}`}
                                    id="emp_No"
                                    name="emp_No"
                                    value={form.emp_No || ''}
                                    onChange={handleFormChange}
                                    placeholder="Employee Number"
                                    maxLength={10}
                                    required={true}
                                  />
                                  {errors.emp_No && (
                                    <div className="invalid-feedback d-block">
                                      {errors.emp_No}
                                    </div>
                                  )}
                                </div>
                              </Col>

                              <Col lg="3">
                                <FormInput
                                  label="Name (English)"
                                  id="employee_NameEn"
                                  name="employee_NameEn"
                                  value={form.employee_NameEn}
                                  onChange={handleFormChange}
                                  error={errors.employee_NameEn}
                                  placeholder="Name in English"
                                />
                              </Col>

                              <Col lg="3">
                                <FormInput
                                  label="Name (Arabic)"
                                  id="employee_NameAr"
                                  name="employee_NameAr"
                                  value={form.employee_NameAr}
                                  onChange={handleFormChange}
                                  error={errors.employee_NameAr}
                                  placeholder="Name in Arabic"
                                  required={false}
                                />
                              </Col>

                              <Col lg="3">
                                <FormSelect
                                  label="Gender"
                                  id="employee_Gender_Id"
                                  name="employee_Gender_Id"
                                  options={genderOptions}
                                  value={genderOptions.find(option => option.value === form.employee_Gender_Id)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Gender_Id')}
                                  error={errors.employee_Gender_Id}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormCheckbox
                                  label="On Work (Active Employee)"
                                  id="onWork"
                                  name="onWork"
                                  checked={form.onWork}
                                  onChange={handleFormChange}
                                  disabled={isEditing && !hasDeletePermission}
                                />
                              </Col>
                            </Row>

                            {/* Contact Information */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Contact Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Contact Information</h6>
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Primary Contact"
                                  id="employee_ContactNumber1"
                                  name="employee_ContactNumber1"
                                  type="text"
                                  value={form.employee_ContactNumber1}
                                  onChange={handleFormChange}
                                  error={errors.employee_ContactNumber1}
                                  placeholder="Primary Contact Number"
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Secondary Contact"
                                  id="employee_ContactNumber2"
                                  name="employee_ContactNumber2"
                                  type="text"
                                  value={form.employee_ContactNumber2}
                                  onChange={handleFormChange}
                                  error={errors.employee_ContactNumber2}
                                  placeholder="Secondary Contact Number"
                                  required={false}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Email"
                                  id="employee_Email"
                                  name="employee_Email"
                                  type="email"
                                  value={form.employee_Email}
                                  onChange={handleFormChange}
                                  error={errors.employee_Email}
                                  placeholder="Enter Email"
                                  required={false}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Birth Date"
                                  id="employee_BirthDate"
                                  name="employee_BirthDate"
                                  type="date"
                                  value={form.employee_BirthDate}
                                  onChange={handleFormChange}
                                  error={errors.employee_BirthDate}
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormSelect
                                  label="Country"
                                  id="employee_Country_Id"
                                  name="employee_Country_Id"
                                  options={countryOptions}
                                  value={countryOptions.find(option => option.value === form.employee_Country_Id)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Country_Id')}
                                  error={errors.employee_Country_Id}
                                  required={false}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="National ID"
                                  id="employee_NatID"
                                  name="employee_NatID"
                                  value={form.employee_NatID}
                                  onChange={handleFormChange}
                                  error={errors.employee_NatID}
                                  placeholder="National ID Number"
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="6">
                                <FormInput
                                  label="National ID Issue Date"
                                  id="employee_NatID_Date"
                                  name="employee_NatID_Date"
                                  type="date"
                                  value={form.employee_NatID_Date}
                                  onChange={handleFormChange}
                                  error={errors.employee_NatID_Date}
                                  required={false}
                                />
                              </Col>

                              <Col lg="6">
                                <FormInput
                                  label="National ID Expiry Date"
                                  id="employee_NatID_ExpDate"
                                  name="employee_NatID_ExpDate"
                                  type="date"
                                  value={form.employee_NatID_ExpDate}
                                  onChange={handleFormChange}
                                  error={errors.employee_NatID_ExpDate}
                                />
                              </Col>
                            </Row>

                            {/* Address Information */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Address Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Address Information</h6>
                            <Row className="mb-3">
                              <Col lg="6">
                                <FormInput
                                  label="Address 1"
                                  id="employee_Address1"
                                  name="employee_Address1"
                                  value={form.employee_Address1}
                                  onChange={handleFormChange}
                                  error={errors.employee_Address1}
                                  placeholder="Primary Address"
                                  required={true}
                                />
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={copyAddress1ToAddress2}
                                  className="mt-1"
                                >
                                  Copy to Address 2
                                </Button>
                              </Col>

                              <Col lg="6">
                                <FormInput
                                  label="Address 2"
                                  id="employee_Address2"
                                  name="employee_Address2"
                                  value={form.employee_Address2}
                                  onChange={handleFormChange}
                                  error={errors.employee_Address2}
                                  placeholder="Secondary Address"
                                  required={false}
                                />
                              </Col>
                            </Row>

                            {/* Employment Information */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Employment Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Employment Information</h6>
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormSelect
                                  label="Company"
                                  id="employee_Business_Id"
                                  name="employee_Business_Id"
                                  options={businessOptions}
                                  value={businessOptions.find(option => option.value === form.employee_Business_Id)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Business_Id')}
                                  error={errors.employee_Business_Id}
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormSelect
                                  label="Department"
                                  id="employee_Department_ID"
                                  name="employee_Department_ID"
                                  options={departmentOptions}
                                  value={departmentOptions.find(option => option.value === form.employee_Department_ID)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Department_ID')}
                                  error={errors.employee_Department_ID}
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormSelect
                                  label="Designation"
                                  id="employee_Designation_ID"
                                  name="employee_Designation_ID"
                                  options={designationOptions}
                                  value={designationOptions.find(option => option.value === form.employee_Designation_ID)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Designation_ID')}
                                  error={errors.employee_Designation_ID}
                                  required={true}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormSelect
                                  label="Branch"
                                  id="employee_Branch_Id"
                                  name="employee_Branch_Id"
                                  options={branchOptions}
                                  value={branchOptions.find(option => option.value === form.employee_Branch_Id)}
                                  onChange={(selectedOption) => handleSelectFormChange(selectedOption, 'employee_Branch_Id')}
                                  error={errors.employee_Branch_Id}
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Join Date"
                                  id="employee_JoinDate"
                                  name="employee_JoinDate"
                                  type="date"
                                  value={form.employee_JoinDate}
                                  onChange={handleFormChange}
                                  error={errors.employee_JoinDate}
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <div className="form-group">
                                  <Label className="col-form-label">
                                    Employment Type
                                  </Label>
                                  <Select
                                    id="employee_EmploymentType"
                                    name="employee_EmploymentType"
                                    value={{
                                      value: form.employee_EmploymentType || '',
                                      label: form.employee_EmploymentType || ''
                                    }}
                                    onChange={(selectedOption) => {
                                      const newValue = selectedOption ? selectedOption.value : '';
                                      setForm(prev => ({
                                        ...prev,
                                        employee_EmploymentType: newValue,
                                        employee_ServiceEndDate: newValue === 'Permanent' ? '' : prev.employee_ServiceEndDate
                                      }));
                                    }}
                                    options={[
                                      { value: 'Permanent', label: 'Permanent' },
                                      { value: 'Contract', label: 'Contract' }
                                    ]}
                                    classNamePrefix="select2-selection"
                                    placeholder="Select Employment Type"
                                  />
                                  {errors.employee_EmploymentType && (
                                    <div className="invalid-feedback d-block">
                                      {errors.employee_EmploymentType}
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </Row>

                            {form.employee_EmploymentType === 'Contract' && (
                              <Row className="mb-3">
                                <Col lg="4">
                                  <FormInput
                                    label="Service End Date"
                                    id="employee_ServiceEndDate"
                                    name="employee_ServiceEndDate"
                                    type="date"
                                    value={form.employee_ServiceEndDate}
                                    onChange={handleFormChange}
                                    error={errors.employee_ServiceEndDate}
                                    required={true}
                                  />
                                </Col>
                              </Row>
                            )}

                            {/* Salary Information */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Salary Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Salary Information</h6>
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Basic Salary"
                                  id="employee_BS"
                                  name="employee_BS"
                                  type="number"
                                  value={form.employee_BS}
                                  onChange={handleFormChange}
                                  error={errors.employee_BS}
                                  placeholder="Enter Basic Salary"
                                  required={true}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="House Rent Allowance"
                                  id="employee_HRA"
                                  name="employee_HRA"
                                  type="number"
                                  value={form.employee_HRA}
                                  onChange={handleFormChange}
                                  error={errors.employee_HRA}
                                  placeholder="Enter HRA"
                                  required={true}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="Transport Allowance"
                                  id="employee_TA"
                                  name="employee_TA"
                                  type="number"
                                  value={form.employee_TA}
                                  onChange={handleFormChange}
                                  error={errors.employee_TA}
                                  placeholder="Enter Transport Allowance"
                                  required={false}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Other Allowance"
                                  id="employee_OA"
                                  name="employee_OA"
                                  type="number"
                                  value={form.employee_OA}
                                  onChange={handleFormChange}
                                  error={errors.employee_OA}
                                  placeholder="Enter Other Allowance"
                                  required={false}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="Food Allowance"
                                  id="employee_FoodAllowance"
                                  name="employee_FoodAllowance"
                                  type="number"
                                  value={form.employee_FoodAllowance}
                                  onChange={handleFormChange}
                                  error={errors.employee_FoodAllowance}
                                  placeholder="Enter Food Allowance"
                                  required={false}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="Communication Allowance"
                                  id="employee_CommunicationAllowance"
                                  name="employee_CommunicationAllowance"
                                  type="number"
                                  value={form.employee_CommunicationAllowance}
                                  onChange={handleFormChange}
                                  error={errors.employee_CommunicationAllowance}
                                  placeholder="Enter Communication Allowance"
                                  required={false}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Utility Allowance"
                                  id="employee_UtilityAllowance"
                                  name="employee_UtilityAllowance"
                                  type="number"
                                  value={form.employee_UtilityAllowance}
                                  onChange={handleFormChange}
                                  error={errors.employee_UtilityAllowance}
                                  placeholder="Enter Utility Allowance"
                                  required={false}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="WPS Salary"
                                  id="wpsSalary"
                                  name="wpsSalary"
                                  type="number"
                                  value={form.wpsSalary}
                                  onChange={handleFormChange}
                                  error={errors.wpsSalary}
                                  placeholder="Enter WPS Salary"
                                  required={true}
                                />
                              </Col>
                              <Col lg="4">
                                <FormInput
                                  label="Gross Salary"
                                  id="employee_GS"
                                  name="employee_GS"
                                  type="number"
                                  value={form.employee_GS}
                                  className="bg-light"
                                  readOnly
                                  disabled
                                />
                              </Col>
                            </Row>

                            {/* Passport & Visa Information */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Passport & Visa Information</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Passport & Visa Information</h6>
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Passport Number"
                                  id="employee_PassportNumber"
                                  name="employee_PassportNumber"
                                  value={form.employee_PassportNumber}
                                  onChange={handleFormChange}
                                  error={errors.employee_PassportNumber}
                                  placeholder="Passport Number"
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Passport Issue Date"
                                  id="employee_Passport_Date"
                                  name="employee_Passport_Date"
                                  type="date"
                                  value={form.employee_Passport_Date}
                                  onChange={handleFormChange}
                                  error={errors.employee_Passport_Date}
                                  required={false}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Passport Expiry Date"
                                  id="employee_Passport_ExpDate"
                                  name="employee_Passport_ExpDate"
                                  type="date"
                                  value={form.employee_Passport_ExpDate}
                                  onChange={handleFormChange}
                                  error={errors.employee_Passport_ExpDate}
                                  required={true}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Visa Number"
                                  id="employee_VisaNumber"
                                  name="employee_VisaNumber"
                                  value={form.employee_VisaNumber}
                                  onChange={handleFormChange}
                                  error={errors.employee_VisaNumber}
                                  placeholder="Visa Number"
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Visa Issue Date"
                                  id="employee_Visa_Date"
                                  name="employee_Visa_Date"
                                  type="date"
                                  value={form.employee_Visa_Date}
                                  onChange={handleFormChange}
                                  error={errors.employee_Visa_Date}
                                  required={false}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Visa Expiry Date"
                                  id="employee_Visa_ExpDate"
                                  name="employee_Visa_ExpDate"
                                  type="date"
                                  value={form.employee_Visa_ExpDate}
                                  onChange={handleFormChange}
                                  error={errors.employee_Visa_ExpDate}
                                  required={true}
                                />
                              </Col>
                            </Row>

                            {/* Labour Card and Employment Type Section */}
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormInput
                                  label="Labour Card Number"
                                  id="employee_LabourCardNumber"
                                  name="employee_LabourCardNumber"
                                  value={form.employee_LabourCardNumber}
                                  onChange={handleFormChange}
                                  error={errors.employee_LabourCardNumber}
                                  placeholder="Labour Card Number"
                                  required={true}
                                />
                              </Col>

                              <Col lg="4">
                                <FormInput
                                  label="Labour Card Expiry"
                                  id="employee_LabourCardExpiry"
                                  name="employee_LabourCardExpiry"
                                  type="date"
                                  value={form.employee_LabourCardExpiry}
                                  onChange={handleFormChange}
                                  error={errors.employee_LabourCardExpiry}
                                  required={true}
                                />
                              </Col>
                            </Row>

                            {/* Group Benefits Section */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary" style={{ fontSize: '1rem' }}>Group Benefits</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Group Benefits</h6>
                            <Row className="mb-3">
                              <Col lg="6">
                                <FormBenefitCheckbox
                                  label="Group Provided Housing"
                                  checkboxName="employee_HousingProvided"
                                  amountName="employee_HousingAmount"
                                  checkboxChecked={form.employee_HousingProvided}
                                  amountValue={form.employee_HousingAmount}
                                  onCheckboxChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked
                                    }
                                  })}
                                  onAmountChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: parseFloat(e.target.value) || 0
                                    }
                                  })}
                                />
                              </Col>
                              <Col lg="6">
                                <FormBenefitCheckbox
                                  label="Group Provided Telephone"
                                  checkboxName="employee_TelephoneProvided"
                                  amountName="employee_TelephoneAmount"
                                  checkboxChecked={form.employee_TelephoneProvided}
                                  amountValue={form.employee_TelephoneAmount}
                                  onCheckboxChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked
                                    }
                                  })}
                                  onAmountChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: parseFloat(e.target.value) || 0
                                    }
                                  })}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col lg="6">
                                <FormBenefitCheckbox
                                  label="Group Provided Food"
                                  checkboxName="employee_FoodProvided"
                                  amountName="employee_FoodAmount"
                                  checkboxChecked={form.employee_FoodProvided}
                                  amountValue={form.employee_FoodAmount}
                                  onCheckboxChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked
                                    }
                                  })}
                                  onAmountChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: parseFloat(e.target.value) || 0
                                    }
                                  })}
                                />
                              </Col>
                              <Col lg="6">
                                <FormBenefitCheckbox
                                  label="Other Group Benefits"
                                  checkboxName="employee_OtherBenefits"
                                  amountName="employee_OtherBenefitsAmount"
                                  checkboxChecked={form.employee_OtherBenefits}
                                  amountValue={form.employee_OtherBenefitsAmount}
                                  onCheckboxChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked
                                    }
                                  })}
                                  onAmountChange={(e) => handleFormChange({
                                    target: {
                                      name: e.target.name,
                                      value: parseFloat(e.target.value) || 0
                                    }
                                  })}
                                />
                              </Col>
                            </Row>

                            {/* Image Upload */}
                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* <h5 className="mb-3 text-primary">Profile Image</h5> */}
                            
                            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                            <h6 className="mb-2 text-primary">Profile Image</h6>
                            <Row className="mb-3">
                              <Col lg="4">
                                <FormGroup>
                                  <Label className="col-form-label">Profile Image</Label>
                                  <Input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    className={errors.employee_ImagePath ? 'is-invalid' : ''}
                                  />
                                  {errors.employee_ImagePath && (
                                    <div className="invalid-feedback">
                                      {errors.employee_ImagePath}
                                    </div>
                                  )}
                                  <ImagePreview 
                                    file={selectedImage} 
                                    existingImage={form.employee_ImagePath} 
                                  />
                                </FormGroup>
                              </Col>
                            </Row>

                            {/* Action Buttons */}
                            <Row>
                              <Col lg="12">
                                <div className="d-flex gap-2">
                                  <Button
                                    color="success"
                                    type="submit"
                                    disabled={loading}
                                  >
                                    {loading ? "Saving..." : (isEditing ? "Update Employee" : "Save Employee")}
                                  </Button>
                                  {isEditing && (
                                    <Button
                                      color="secondary"
                                      type="button"
                                      onClick={handleCancelEdit}
                                    >
                                      Cancel Edit
                                    </Button>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>
                        )}

                        <TabPane tabId={2}>
                          {/* Filter Section */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <h5 className="mb-0 fw-bold">Filter Employees</h5>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => setShowFilters(!showFilters)}
                              >
                                {showFilters ? "Hide Filters" : "Show Filters"}
                              </Button>
                            </div>

                            {showFilters && (
                              <Card>
                                <CardBody style={{padding: '1rem'}}>
                                  {/* Basic Info Filters */}
                                  {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                                  {/* <h6 className="text-primary mb-3">Basic Information</h6> */}
                                  
                                  {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                                  {/* Basic Information heading removed for space optimization */}
                                  <Row className="mb-2">
                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Code">Employee Code</Label>
                                        <Select
                                          options={employeeCodeOptions}
                                          value={employeeCodeOptions.find(option => option.value === filter.employee_Code)}
                                          placeholder="Select Employee Code"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Code')}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_NameEn">Name (English)</Label>
                                        <Select
                                          options={employeeNameEnOptions}
                                          value={employeeNameEnOptions.find(option => option.value === filter.employee_NameEn)}
                                          placeholder="Select Name (English)"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_NameEn')}
                                        />
                                      </div>
                                    </Col>

                                    {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                                    {/* <Col lg="3"> */}
                                    {/*   <div className="form-group"> */}
                                    {/*     <Label htmlFor="filter_employee_NameAr">Name (Arabic)</Label> */}
                                    {/*     <Select */}
                                    {/*       options={employeeNameArOptions} */}
                                    {/*       value={employeeNameArOptions.find(option => option.value === filter.employee_NameAr)} */}
                                    {/*       placeholder="Select Name (Arabic)" */}
                                    {/*       classNamePrefix="select2-selection" */}
                                    {/*       isClearable={true} */}
                                    {/*       isSearchable={true} */}
                                    {/*       onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_NameAr')} */}
                                    {/*     /> */}
                                    {/*   </div> */}
                                    {/* </Col> */}

                                    {/* MERLOT THEME - NEW VALUES (FILTER REMOVED): */}
                                    {/* Name (Arabic) filter removed as requested */}

                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Business_Id">Company</Label>
                                        <Select
                                          id="filter_employee_Business_Id"
                                          name="filter_employee_Business_Id"
                                          options={businessOptions}
                                          value={businessOptions.find(option => option.value === filter.employee_Business_Id)}
                                          placeholder="Select Company"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Business_Id')}
                                        />
                                      </div>
                                    </Col>
                                  </Row>

                                  {/* Employment Filters */}
                                  {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                                  {/* <h6 className="text-primary mb-3">Employment Information</h6> */}
                                  
                                  {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                                  {/* Employment Information heading removed for space optimization */}
                                  <Row className="mb-2">
                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Department_ID">Department</Label>
                                        <Select
                                          id="filter_employee_Department_ID"
                                          name="filter_employee_Department_ID"
                                          options={departmentOptions}
                                          value={departmentOptions.find(option => option.value === filter.employee_Department_ID)}
                                          placeholder="Select Department"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Department_ID')}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Designation_ID">Designation</Label>
                                        <Select
                                          id="filter_employee_Designation_ID"
                                          name="filter_employee_Designation_ID"
                                          options={designationOptions}
                                          value={designationOptions.find(option => option.value === filter.employee_Designation_ID)}
                                          placeholder="Select Designation"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Designation_ID')}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Branch_Id">Branch</Label>
                                        <Select
                                          id="filter_employee_Branch_Id"
                                          name="filter_employee_Branch_Id"
                                          options={branchOptionsForFilter}
                                          value={branchOptionsForFilter.find(option => option.value === filter.employee_Branch_Id)}
                                          placeholder="Select Branch"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Branch_Id')}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="3">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Gender_Id">Gender</Label>
                                        <Select
                                          options={genderOptions}
                                          value={genderOptions.find(option => option.value === filter.employee_Gender_Id)}
                                          placeholder="Select Gender"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Gender_Id')}
                                        />
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row className="mb-2">
                                    <Col lg="4">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_Country_Id">Country</Label>
                                        <Select
                                          options={countryOptions}
                                          value={countryOptions.find(option => option.value === filter.employee_Country_Id)}
                                          placeholder="Select Country"
                                          classNamePrefix="select2-selection"
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Country_Id')}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="4">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_JoinDate">Join Date</Label>
                                        <Input
                                          type="date"
                                          className="form-control"
                                          id="filter_employee_JoinDate"
                                          name="employee_JoinDate"
                                          value={filter.employee_JoinDate || ""}
                                          onChange={handleFilterChange}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="4">
                                      <div className="form-group" style={{marginBottom: '0.5rem'}}>
                                        <Label htmlFor="filter_employee_BirthDate">Birth Date</Label>
                                        <Input
                                          type="date"
                                          className="form-control"
                                          id="filter_employee_BirthDate"
                                          name="employee_BirthDate"
                                          value={filter.employee_BirthDate || ""}
                                          onChange={handleFilterChange}
                                        />
                                      </div>
                                    </Col>
                                  </Row>

                                  {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                                  {/* System Filters */}
                                  {/* <h6 className="text-primary mb-3">System Information</h6> */}
                                  {/* <Row className="mb-3"> */}
                                  {/*   <Col lg="4"> */}
                                  {/*     <div className="form-group"> */}
                                  {/*       <Label htmlFor="filter_employee_CreatedBy">Created By</Label> */}
                                  {/*       <Select */}
                                  {/*         options={createdByOptions} */}
                                  {/*         value={createdByOptions.find(option => option.value === filter.employee_CreatedBy)} */}
                                  {/*         placeholder="Select Created By" */}
                                  {/*         classNamePrefix="select2-selection" */}
                                  {/*         isClearable={true} */}
                                  {/*         isSearchable={true} */}
                                  {/*         onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_CreatedBy')} */}
                                  {/*       /> */}
                                  {/*     </div> */}
                                  {/*   </Col> */}

                                  {/*   <Col lg="4"> */}
                                  {/*     <div className="form-group"> */}
                                  {/*       <Label htmlFor="filter_employee_ModifiedBy">Modified By</Label> */}
                                  {/*       <Select */}
                                  {/*         options={modifiedByOptions} */}
                                  {/*         value={modifiedByOptions.find(option => option.value === filter.employee_ModifiedBy)} */}
                                  {/*         placeholder="Select Modified By" */}
                                  {/*         classNamePrefix="select2-selection" */}
                                  {/*         isClearable={true} */}
                                  {/*         isSearchable={true} */}
                                  {/*         onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_ModifiedBy')} */}
                                  {/*       /> */}
                                  {/*     </div> */}
                                  {/*   </Col> */}

                                  {/*   <Col lg="4"> */}
                                  {/*     <div className="form-group"> */}
                                  {/*       <Label htmlFor="filter_employee_CreatedDate">Created Date</Label> */}
                                  {/*       <Input */}
                                  {/*         type="date" */}
                                  {/*         className="form-control" */}
                                  {/*         id="filter_employee_CreatedDate" */}
                                  {/*         name="employee_CreatedDate" */}
                                  {/*         value={filter.employee_CreatedDate || ""} */}
                                  {/*         onChange={handleFilterChange} */}
                                  {/*       /> */}
                                  {/*     </div> */}
                                  {/*   </Col> */}
                                  {/* </Row> */}

                                  {/* MERLOT THEME - NEW VALUES (FILTERS REMOVED): */}
                                  {/* System Information filters removed as requested */}

                                  <div className="d-flex gap-2 mt-2">
                                    <Button
                                      color="primary"
                                      onClick={handleApplyFilter}
                                      disabled={loading}
                                    >
                                      Apply Filter
                                    </Button>
                                    <Button
                                      color="warning"
                                      onClick={handleClearFilter}
                                    >
                                      Clear Filter
                                    </Button>
                                  </div>
                                </CardBody>
                              </Card>
                            )}
                          </div>

                          {/* Employee Table */}
              <Card style={{backgroundColor: '#ffffff'}}>
                <CardBody style={{backgroundColor: '#ffffff', paddingTop: '0.5rem'}}>
                              {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                              {/* <h5 className="mb-3">Employee List ({employees.length} records)</h5> */}
                              
                              {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                              <h6 className="mb-2" style={{fontSize: '0.9rem'}}>Employee List ({employees.length} records)</h6>
                              
                              {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                              {/* <div style={{ maxHeight: "60vh", overflowY: "auto", overflowX: "auto" }}> */}
                              {/*   <Table bordered responsive> */}
                              
                              {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                              {loading ? (
                                <p>Loading employees...</p>
                              ) : (
                                <div style={{ overflowX: "auto" }} className="employee-list-optimized">
                                  <Table bordered responsive className="table-optimized">
                                    <thead>
                                      <tr>
                                        <th>Sl.No</th>
                                        <th>Actions</th>
                                        <th>Profile</th>
                                        <th>Code</th>
                                        <th>Emp No</th>
                                        <th>Name (EN)</th>
                                        <th>Name (AR)</th>
                                        <th>Company</th>
                                        <th>Department</th>
                                        <th>Designation</th>
                                        <th>Branch</th>
                                        <th>Gender</th>
                                        <th>Country</th>
                                        <th>Birth Date</th>
                                        <th>Join Date</th>
                                        <th>National ID</th>
                                        <th>Passport</th>
                                        <th>Visa</th>
                                        <th>Address 1</th>
                                        <th>Basic Salary</th>
                                        <th>HRA</th>
                                        <th>Transport</th>
                                        <th>Other Allow.</th>
                                        <th>WPS Salary</th>
                                        <th>Gross Salary</th>
                                        <th>Work Status</th>
                                        <th>Probation</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {employees.length === 0 ? (
                                        <tr>
                                          <td colSpan="27" className="text-center">
                                            No employees found
                                          </td>
                                        </tr>
                                      ) : (
                                        employees.map((emp, index) => (
                                          <tr key={emp.employee_Id}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>
                                              <div className="d-flex gap-2">
                                                {hasEditOrHigher && (
                                                  <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => handleEdit(emp)}
                                                  >
                                                    Edit
                                                  </Button>
                                                )}
                                                <Button
                                                  color="primary"
                                                  size="sm"
                                                  onClick={() => handleView(emp)}
                                                >
                                                  View
                                                </Button>
                                              </div>
                                            </td>
                                            <td>
                                              {emp.employee_ImagePath ? (
                                                <img
                                                  src={`${API_URL}${emp.employee_ImagePath}`}
                                                  alt={emp.employee_NameEn}
                                                  style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                  }}
                                                />
                                              ) : (
                                                <div
                                                  style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#e9ecef',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                  }}
                                                >
                                                  <i className="bx bx-user" />
                                                </div>
                                              )}
                                            </td>
                                            <td>{emp.emp_No}</td>
                                            <td>{emp.Emp_No}</td>
                                            <td>{emp.employee_NameEn}</td>
                                            <td>{emp.employee_NameAr}</td>
                                            <td>{emp.business_name}</td>
                                            <td>{emp.department_name}</td>
                                            <td>{emp.designation_name}</td>
                                            <td>{emp.branch_name}</td>
                                            <td>{emp.gender_name}</td>
                                            <td>{emp.country_name}</td>
                                            <td>{formatDate(emp.employee_BirthDate)}</td>
                                            <td>{formatDate(emp.employee_JoinDate)}</td>
                                            <td>{emp.employee_NatID}</td>
                                            <td>{emp.employee_PassportNumber}</td>
                                            <td>{emp.employee_VisaNumber}</td>
                                            <td>{emp.employee_Address1}</td>
                                            <td className="text-end">{emp.employee_BS?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td className="text-end">{emp.employee_HRA?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td className="text-end">{emp.employee_TA?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td className="text-end">{emp.employee_OA?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td className="text-end">{emp.wpsSalary?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td className="text-end">{emp.employee_GS?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td>
                                              <span className={`badge ${emp.onWork ? 'bg-success' : 'bg-secondary'}`}>
                                                {emp.onWork ? 'On Work' : 'Not On Work'}
                                              </span>
                                            </td>
                                            <td>
                                              <span className={`badge ${emp.employee_IsOnProbation ? 'bg-warning' : 'bg-success'}`}>
                                                {emp.employee_IsOnProbation ? 'Yes' : 'No'}
                                              </span>
                                            </td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              )}

                                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                                            {/* <div className="d-flex justify-content-between align-items-center mt-4 p-3" 
                   style={{backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6'}}> */}
                                           
                                           {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                                           <div className="d-flex justify-content-between align-items-center mt-2 p-2" 
                   style={{backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6'}}>
                {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                {/* <div className="text-muted" style={{fontSize: '14px', fontWeight: '500'}}> */}
                
                {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                <div className="text-muted" style={{fontSize: '12px', fontWeight: '500'}}>
                  <i className="mdi mdi-information-outline me-2" style={{color: '#556ee6'}}></i>
                  Showing <span style={{color: '#556ee6', fontWeight: '600'}}>{employees.length > 0 ? (page - 1) * pageSize + 1 : 0}</span> to <span style={{color: '#556ee6', fontWeight: '600'}}>{Math.min(page * pageSize, totalCount)}</span> of <span style={{color: '#556ee6', fontWeight: '600'}}>{totalCount}</span> entries
                </div>
                {totalCount > pageSize && (
                  <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <Button
                      color="light"
                      size="sm"
                      disabled={page === 1}
                      onClick={() => handlePageChange(page - 1)}
                      style={{
                        border: '1px solid #dee2e6',
                        borderRadius: '0.375rem',
                        minWidth: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: page === 1 ? '#f8f9fa' : '#fff',
                        color: page === 1 ? '#6c757d' : '#495057',
                        fontSize: '0.8rem'
                      }}
                    >
                      <i className="mdi mdi-chevron-left"></i>
                    </Button>
                    
                    {[...Array(Math.ceil(totalCount / pageSize))].map((_, index) => {
                      const pageNum = index + 1;
                      const isActive = page === pageNum;
                      
                      return (
                        <Button
                          key={pageNum}
                          color={isActive ? "primary" : "light"}
                          size="sm"
                          onClick={() => handlePageChange(pageNum)}
                          style={{
                            border: '1px solid #dee2e6',
                            borderRadius: '0.375rem',
                            minWidth: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: isActive ? '#556ee6' : '#fff',
                            borderColor: isActive ? '#556ee6' : '#dee2e6',
                            color: isActive ? '#fff' : '#495057',
                            fontWeight: isActive ? '600' : '400',
                            fontSize: '0.8rem',
                            boxShadow: isActive ? '0 2px 4px rgba(85,110,230,0.25)' : 'none'
                          }}
                        >
                          {pageNum}
                        </Button>
                      );
                    })}
                    
                    <Button
                      color="light"
                      size="sm"
                      disabled={page === Math.ceil(totalCount / pageSize)}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        border: '1px solid #dee2e6',
                        borderRadius: '0.375rem',
                        minWidth: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: page === Math.ceil(totalCount / pageSize) ? '#f8f9fa' : '#fff',
                        color: page === Math.ceil(totalCount / pageSize) ? '#6c757d' : '#495057',
                        fontSize: '0.8rem'
                      }}
                    >
                      <i className="mdi mdi-chevron-right"></i>
                    </Button>
                  </div>
                )}
              </div>
                            </CardBody>
                          </Card>
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add the modal component */}
      <EmployeeDetailsModal
        isOpen={viewModal}
        toggle={() => setViewModal(!viewModal)}
        employee={selectedEmployee}
      />
    </React.Fragment>
  );
}